/*
  Controls the popup hierarchy of the following apps
  - One Trust
  - Global-e
  - Klaviyo
 */

const popupHierarchyInitTime = Date.now()

/**
 * Look for open klaviyo toggle and fire click event
 * Need the delay to wait for button to be generated
 * @param {Node} klaviyoPopupParent : Klaviyo parent node
 */
const openKlaviyoFormFromOneTrust = (klaviyoPopupParent, bodyElemTarget) => {
  setTimeout(() => {
    const klaviyoOpenButton = klaviyoPopupParent?.querySelector('button') || null
    klaviyoOpenButton?.dispatchEvent(new Event('click'))
    bodyElemTarget.classList.remove('hide-klaviyo-popup')
  }, 1000)
}

/**
 * Main function to run on a mutation
 * @param {Object} hierarchyObserver : Mutation Observer
 */
const hierarchyObserverMutationCallback = (hierarchyObserver) => {
  const bodyElemTarget = document.documentElement || document.body

  // Control Global E
  const globalePopup = document.querySelector('#md-app-embed__modal')
  const isGlobalePopupVisible = (globalePopup !== null && globalePopup.style.display !== 'none')

  globalePopup?.classList.toggle(
    'popup-force-hide',
    (globalePopup && !isGlobalePopupVisible)
  )

  // Control One Trust
  const oneTrustPopup = document.querySelector('#onetrust-consent-sdk')
  const oneTrustPopupBanner = document.querySelector('#onetrust-banner-sdk')
  const isOneTrustVisiable =
    oneTrustPopupBanner !== null && oneTrustPopupBanner.style.display !== 'none'

  oneTrustPopup?.classList.toggle(
    'popup-force-hide',
    (oneTrustPopup && !isOneTrustVisiable) || isGlobalePopupVisible
  )

  // Control Klaviyo
  const klaviyoPopup =
    document.querySelector('div[aria-label="POPUP Form"].needsclick')
      ?.parentNode || null
  const klaviyoPopupParent = klaviyoPopup?.parentNode || null

  klaviyoPopupParent?.classList.toggle(
    'popup-force-hide',
    isGlobalePopupVisible || isOneTrustVisiable
  )

  // Set up event to open Klaviyo when onetrust is accepeted
  const oneTrustAcceptButton = document.querySelector('#onetrust-accept-btn-handler')
  if (
    oneTrustAcceptButton &&
    klaviyoPopupParent &&
    !oneTrustAcceptButton.hasAttribute('data-klaviyo-trigger-init')
  ) {
    oneTrustAcceptButton.dataset.klaviyoTriggerInit = true
    oneTrustAcceptButton.addEventListener('click', () => {
      openKlaviyoFormFromOneTrust(klaviyoPopupParent, bodyElemTarget)
    })
  }

  // Disconnect observer if onetrust and global-e aren't visiable, and after load buffer
  const loadBuffer = ((Date.now() - popupHierarchyInitTime) > 2500)
  if (!isOneTrustVisiable && !isGlobalePopupVisible && loadBuffer) {
    hierarchyObserver.disconnect()
    globalePopup?.classList.remove('popup-force-hide')
    oneTrustPopup?.classList.remove('popup-force-hide')
    klaviyoPopupParent?.classList.remove('popup-force-hide')

    setTimeout(() => {
      bodyElemTarget.classList.remove('hide-klaviyo-popup')
    }, 1000)
  }
}

/**
 * Set up observer
 */
const popupHierarchyControl = () => {
  const bodyElemTarget = document.documentElement || document.body
  bodyElemTarget.classList.add('hide-klaviyo-popup')
  const hierarchyObserverConfig = { attributes: true, childList: true, subtree: true };
  const hierarchyObserver = new MutationObserver(() => hierarchyObserverMutationCallback(hierarchyObserver))
  hierarchyObserver.observe(bodyElemTarget, hierarchyObserverConfig);
}

/**
 * Call popupHierarchyControl after DOM content load
 */
document.addEventListener('DOMContentLoaded', popupHierarchyControl)
